import { render, staticRenderFns } from "./buttonsHeader.vue?vue&type=template&id=04c72535&"
import script from "./buttonsHeader.vue?vue&type=script&lang=js&"
export * from "./buttonsHeader.vue?vue&type=script&lang=js&"
import style0 from "./buttonsHeader.vue?vue&type=style&index=0&id=04c72535&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports